module.exports = __webpack_public_path__ + "static/img/jigou-ningbo-bottom.d6bf3c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-ningbo-bottom.jpg
// module id = CsAu
// module chunks = 2